export enum CONSET_STATUS {
  CONFIRMED = 'CONFIRMED',
  WITHDRAWN = 'WITHDRAWN',
  OPT_OUT = 'OPT_OUT',
  NO_OPT_OUT = 'NO_OUPT_OUT',
}
